import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ion-text-center today-header" }
const _hoisted_2 = { class: "white-bold" }
const _hoisted_3 = {
  key: 0,
  class: "events-section"
}
const _hoisted_4 = {
  ref: "eventsScrollWrap",
  class: "events-scroll-wrap"
}
const _hoisted_5 = { class: "events-scroll" }
const _hoisted_6 = { class: "event-image-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "event-overlay" }
const _hoisted_9 = { class: "event-title" }
const _hoisted_10 = { class: "event-meta" }
const _hoisted_11 = { class: "event-location" }
const _hoisted_12 = {
  key: 0,
  class: "event-paid-badge"
}
const _hoisted_13 = {
  key: 1,
  class: "event-soldout-badge"
}
const _hoisted_14 = {
  key: 2,
  class: "event-registered-badge"
}
const _hoisted_15 = {
  key: 3,
  class: "event-count-badge"
}
const _hoisted_16 = { class: "event-skeleton-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "events-all-link"
}
const _hoisted_18 = {
  key: 1,
  class: "events-empty"
}
const _hoisted_19 = {
  key: 1,
  class: "programs-section"
}
const _hoisted_20 = { class: "programs-grid" }
const _hoisted_21 = { class: "program-image-container" }
const _hoisted_22 = {
  key: 0,
  class: "program-skeleton-wrapper"
}
const _hoisted_23 = ["src", "alt", "onLoad", "onError"]
const _hoisted_24 = { class: "program-overlay" }
const _hoisted_25 = { class: "program-description" }
const _hoisted_26 = {
  key: 2,
  class: "offline-section"
}
const _hoisted_27 = { class: "offline-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass(['main-background', 'today-content']),
        fullscreen: true,
        "scroll-y": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
            ]),
            _: 1
          }, 8, ["onIonRefresh"]),
          _createElementVNode("header", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "header-title white-bold" }, "Сегодня", -1)),
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.now), 1)
          ]),
          (!_ctx.globalContext.offlineMode && _ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "section-title" }, "События", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingEvents, (ev) => {
                      return (_openBlock(), _createBlock(_component_ion_card, {
                        key: ev.id,
                        class: "event-card",
                        onClick: ($event: any) => (_ctx.$router.push(`/events/${ev.id}`))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("img", {
                              src: ev.logoPath ? _ctx.eventsService.logoUrl(ev.logoPath, 640) : _ctx.fallbackLogo,
                              alt: ev.title,
                              class: "event-image",
                              loading: "lazy"
                            }, null, 8, _hoisted_7),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("h3", _hoisted_9, _toDisplayString(ev.title), 1),
                              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formatEventDate(ev.startAt)), 1),
                              _createElementVNode("p", _hoisted_11, _toDisplayString(ev.location || 'Место уточняется'), 1),
                              (ev.isPaid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Платное"))
                                : _createCommentVNode("", true),
                              (_ctx.isSoldOut(ev))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Sold out"))
                                : _createCommentVNode("", true),
                              (_ctx.isRegistered(ev))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Записан"))
                                : _createCommentVNode("", true),
                              (_ctx.registrationsBadge(ev))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.registrationsBadge(ev)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.upcomingEvents.length === 0 && _ctx.isLoadingEvents ? 4 : 0), (n) => {
                      return (_openBlock(), _createBlock(_component_ion_card, {
                        key: 'event-skeleton-' + n,
                        class: "event-card event-card--skeleton"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"100%","height":"100%"}
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    }), 128))
                  ])
                ], 512),
                (_ctx.upcomingEvents.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_router_link, { to: "/events" }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("Все события →", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : (!_ctx.isLoadingEvents)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "events-empty-text" }, "Нет предстоящих событий.", -1)),
                        _createVNode(_component_router_link, {
                          to: "/events",
                          class: "events-empty-link"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Перейти к событиям", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.globalContext.offlineMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "section-title" }, "Программы", -1)),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePrograms, (program) => {
                    return (_openBlock(), _createBlock(_component_ion_card, {
                      key: program.shortName,
                      class: "program-card",
                      onClick: ($event: any) => (_ctx.navigateToProgram(program))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          (!_ctx.programLogos[program.shortName] && _ctx.isLoadingLogos)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"100%","height":"100%"}
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.programLogos[program.shortName] || _ctx.fallbackLogo,
                                alt: program.name,
                                class: "program-image",
                                onLoad: ($event: any) => (_ctx.onProgramImageLoad(program.shortName)),
                                onError: ($event: any) => (_ctx.onProgramImageError(program.shortName))
                              }, null, 40, _hoisted_23)),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("p", _hoisted_25, _toDisplayString(program.description), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.globalContext.offlineMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.cloudOffline,
                    class: "offline-icon"
                  }, null, 8, ["icon"]),
                  _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "offline-title" }, "РЕЖИМ ОФФЛАЙН", -1)),
                  _createVNode(_component_ion_button, {
                    class: "reconnect-button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reconnect())),
                    disabled: _ctx.reconnecting
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.reconnecting]
                      ]),
                      _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                        [_vShow, _ctx.reconnecting]
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}